import { combineReducers } from 'redux';
import reduceDataLogin from './reducer/reduceDataLogin';
import changeState from './reducer/reducerChangeState';
import reduceClientBoxData from './reducer/reduceClientBoxData';
import reduceDataDeviceDetail from './reducer/reduceDataDeviceDetail';
const ReduceAll = combineReducers({
    login: reduceDataLogin,
    changeState: changeState,
    clientBoxData: reduceClientBoxData,
    deviceDetail: reduceDataDeviceDetail
})

const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        state = undefined;
    }
    return ReduceAll(state, action);
}

export default rootReducer;